import { connect } from 'react-redux'
import * as advancedAlertModalActions from '../AlertModals/AdvancedAlertModal/actions'
import * as basicAlertModalActions from '../AlertModals/BasicAlertModal/actions'
import * as alertsSelectors from '..//selectors'
import * as selectors from './selectors'
import * as actions from './actions'
import * as basicAlertActions from '../AlertModals/BasicAlertModal/actions'
import { default as AlertsListPage, EventProps, ExternalProps, Props } from './AlertsListPage'
import { selectors as authSelectors } from '../.././../lifecycle/auth'
import { AppState, Dispatch } from '../../../types'
import { AlertsFilters } from './model'
import { EmptyStatePageStateOverride } from '../../EmptyStatePage/model'
import { changeEmptyState } from '../../EmptyStatePage/actions'
import FeatureFlagService from '../../../services/FeatureFlagService'
import FeatureFlags from '../../../types/featureflags'

const isAlertTypeFilterEnabled = (isTitanium: boolean): boolean => {
  return isTitanium && FeatureFlagService.get(FeatureFlags.ALERTS_BASIC_ADVANCED_FILTER_ENABLED)
}

const mapProps = (state: AppState, ownProps: ExternalProps): Props => {
  const isTitanium = authSelectors.isMonitoringCenterPremium(state)
  const isFlagEnabled = FeatureFlagService.get(FeatureFlags.ALERTS_TYPE_FILTER_BANNER_ENABLED)
  const shouldShowBanner = isTitanium && isFlagEnabled
  return {
    ...ownProps,
    isTitanium,
    shouldShowBanner,
    isBasicAlertsEnabled: alertsSelectors.isBasicAlertsEnabled(state),
    isAPIBasicAlertsEnabled: alertsSelectors.isAPIBasicAlertsEnabled(state) && window.mc.featureFlags.alerts.apiAlerts.enabled === 'true',
    isBasicAlertsLimitExceeded: alertsSelectors.isBasicAlertsLimitExceeded(state),
    isAlertTypeFilterEnabled: isAlertTypeFilterEnabled(isTitanium),
    organizationDomain: authSelectors.getOrganizationDomain(state),
    alerts: selectors.getAlerts(state),
    filteredAlerts: selectors.getFilteredAlerts(state),
    loading: selectors.isLoading(state),
    filters: selectors.getFilters(state),
    toasts: state.monitoring.toasts.toastList,
    hasEditRole: authSelectors.hasEditRole(state),
    organizationId: authSelectors.getOrganizationId(state),
    authorization: authSelectors.getAuthorization(state),
    profile: authSelectors.getProfile(state)
  }
}

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  fetchAllAlerts: (firstFetch?: boolean) => dispatch(actions.fetchAllAlerts(firstFetch)),
  pauseAlert: (alertId: string, state: boolean) => dispatch(actions.pauseAlert(alertId, state)),
  changeExistingAlertByAlertId: (alertId: string) => dispatch(basicAlertActions.changeExistingAlertByAlertId(alertId)),
  filterChange: (key: string, value: string, fetch?: boolean) => dispatch(actions.filterChange(key, value)),
  filterWithSearch: (input?: string) => dispatch(actions.filterWithSearch(input)),
  fetchAllFilteredAlerts: (filters: AlertsFilters & {search?: string}) => dispatch(actions.fetchAlerts(filters, true)),
  handleRedirectAlertLink: (basicAlertId?: string) => dispatch(actions.handleRedirectAlertLink(basicAlertId)),
  handleOpenBasicAlertModal: () => dispatch(basicAlertModalActions.handleOpen()),
  handleOpenAdvancedAlertModal: () => dispatch(advancedAlertModalActions.handleOpen()),
  changeColumnSort: (column: string, ascending: boolean) => dispatch(actions.changeColumnSort(column, ascending)),
  redirectTo404Page: (emptyState: EmptyStatePageStateOverride) => dispatch(changeEmptyState(404, emptyState))
})

export default connect(mapProps, mapDispatch)(AlertsListPage)
